import React from "react";
import { Button, Checkbox, Input } from "@material-tailwind/react";

const GDPRTab = ({ formData, handlers, arrayState }) => {
  const {
    handleInputChange,
    handleCheckBoxChange,
    handleNestedCheckBoxChange,
    handleAddTag,
    handleRemoveTag
  } = handlers;

  const {
    newTag,
    setNewTag
  } = arrayState;

  return (
    <div className="space-y-4">
      <div className="border p-4 rounded-md mb-4">
        <h3 className="text-sm font-medium mb-3">Communication Consent</h3>
        <div className="flex gap-4 justify-between items-center mb-4">
          <div className="w-full">
            <Checkbox
              name="communicationConsent"
              checked={formData.communicationConsent}
              onChange={handleCheckBoxChange}
              label="Communication Consent Given"
            />
          </div>

          <Input
            label="Consent Date"
            name="consentDate"
            type="date"
            value={formData.consentDate ? new Date(formData.consentDate).toISOString().split('T')[0] : ''}
            onChange={handleInputChange}
          />
        </div>

        <h4 className="text-sm font-medium my-2">Communication Preferences</h4>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          <Checkbox
            label="Email"
            checked={formData.communicationPreferences?.email || false}
            onChange={() => handleNestedCheckBoxChange('communicationPreferences', 'email', !formData.communicationPreferences?.email)}
          />
          <Checkbox
            label="Phone"
            checked={formData.communicationPreferences?.phone || false}
            onChange={() => handleNestedCheckBoxChange('communicationPreferences', 'phone', !formData.communicationPreferences?.phone)}
          />
          <Checkbox
            label="SMS"
            checked={formData.communicationPreferences?.sms || false}
            onChange={() => handleNestedCheckBoxChange('communicationPreferences', 'sms', !formData.communicationPreferences?.sms)}
          />
          <Checkbox
            label="Direct Mail"
            checked={formData.communicationPreferences?.directMail || false}
            onChange={() => handleNestedCheckBoxChange('communicationPreferences', 'directMail', !formData.communicationPreferences?.directMail)}
          />
          <Checkbox
            label="WhatsApp"
            checked={formData.communicationPreferences?.whatsapp || false}
            onChange={() => handleNestedCheckBoxChange('communicationPreferences', 'whatsapp', !formData.communicationPreferences?.whatsapp)}
          />
        </div>
      </div>
      <div className="border p-3 rounded-md">
        <h3 className="text-sm font-medium mb-2">Tags</h3>
        <div className="flex gap-2">
          <Input
            label="Add Tag"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            className="flex-grow"
          />
          <Button size="sm" onClick={handleAddTag}>Add</Button>
        </div>
        <div className="mt-2 flex flex-wrap gap-2">
          {formData.tags?.map((tag, index) => (
            <div key={index} className="inline-flex items-center bg-blue-50 text-blue-700 rounded-full px-3 py-1 text-sm">
              {tag}
              <button
                type="button"
                className="ml-2 text-blue-500 hover:text-blue-700"
                onClick={() => handleRemoveTag(index)}
              >
                &times;
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GDPRTab;